import { render, staticRenderFns } from "./EvaluateWeekUpdateDialog.vue?vue&type=template&id=9a396002&scoped=true"
import script from "./EvaluateWeekUpdateDialog.vue?vue&type=script&lang=js"
export * from "./EvaluateWeekUpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./EvaluateWeekUpdateDialog.vue?vue&type=style&index=0&id=9a396002&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a396002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a396002')) {
      api.createRecord('9a396002', component.options)
    } else {
      api.reload('9a396002', component.options)
    }
    module.hot.accept("./EvaluateWeekUpdateDialog.vue?vue&type=template&id=9a396002&scoped=true", function () {
      api.rerender('9a396002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/EvaluateWeekUpdateDialog.vue"
export default component.exports